export class MesaggeText {
  static TEXT_OK_SEND: string = "Solicitud enviada";
  static FIELD_REQUIER: string =
    "Apreciado colaborador debe ingresar todos los datos obligatorios";
  static FIELD_EMPTY_USER: string =
    "Debe Ingresar el usuario, por favor verificar";
  static FIELD_EMPTY_PASSWORD: string =
    "Debe Ingresar la clave, por favor verificar";
  static TITLE_ALERT: string = "Alerta";
  static TEXT_EXIT_APP: string = "¿Seguro que desea salir de la aplicación?";
  static LEN_MAX_CHAR: string = "no cumple con el número carateres ({0}).";
  static LEN_MIN_CHAR: string = "no cumple con el número carateres ({0}).";
  static ERROR_CONNETION: string =
    "No hay conexión con el servidor, por favor valida su conexión si tiene acceso a internet o esperar más tarde";
  static NOT_MENU: string =
    "No se puede ingresar a la aplicación porque no tiene acceso a ningun menu";
  static VALUE_MAX_CHAR: string =
    "No cumple el valor con el maxímo valor ({0})";
  static VALUE_MIN_CHAR: string =
    "No cumple el valor con el minímo valor ({0})";
  static ERROR_SAVE_FORM: string =
    "No se pudo guardar los datos, valida la conexión a internet o valida más tarde";
  static TITLE_SAVE: string = "Error al guardar";
  static TEXT_CANCEL_CLIENT: string =
    "Seguro que desea cancelar la solicitud ? ";
  static TITLE_CANCEL_CLIENT: string = "Cancelar Solicitud";
  static TEXT_FINSH_CLIENT: string =
    "Seguro que desea finalizar la solicitud y pasarla al momento 2";
  static TITLE_FINSH_CLIENT: string = "Finalizar Solicitud";

  static FILE_SIZE_NOT_SOPORT: string =
    "El archivo {0} excede el tamaño permitido de 4 MB";
  static TEXT_CONTINUE_CLIENT: string =
    "Seguro que desea continuar con el momento 2";
  static TITLE_CONTINUE_CLIENT: string = "Continuar Momento 2";
  static TEXT_NOT_FILES: string = "Debe abjuntar al menos un archivo";
  static TEXT_DELETE_ITEM: string = "¿Desea eliminar el registo?";
  static TITLE_DELETE_ITEM: string = "Eliminar";
  static PERCERTAGE_MAYOR: string = "La suma del porcentaje supera 100%";
  static PERCERTAGE_MINOR: string =
    "El porcentaje ingresado debe ser mayor o igual 1%";
  static TITLE_INCONSISTENCY: string = "Inconsistencia";
  static TEXT_SEND_INCONSISTENCY: string = "Enviar una Incosistencia";
  static TEXT_SEND_TO_SIGN: string = "Enviar por firmar";
  static TITLE_TO_SIGN: string = "Esta a un paso de enviar Por Firmar, recuerde que si el correo de confirmacion es diferente al correo ingresado inicialmente. El sistema tomara en cuenta el correo de confirmación.";
  static TEXT_DELETE_SOLICITUDE: string =
    "¿Desea eliminar esta solicitud de forma permanente en el sistema?";
  static TITLE_DELETE_SOLICITUDE: string = "Eliminar solicitud";
  static TEXT_EDIT_SOLICITUDE: string = "¿Desea ir a editar la solicitud?";
  static TITLE_EDIT_SOLICITUDE: string = "Editar Solicitud";
  static TITLE_CANCEL_SOLICITUDE: string = "Cancelar Solicitud";
  static TEXT_CANCEL_SOLICITUDE: string =
    "¿Desea cancelar este proceso de vinculacion en el sistema?";
  static TEXT_NOT_100_PERCENTAJE: string = "No se ha completado el 100%";
  static TEXT_NOT_SELECT_ASSIGN: string = "Debe selecionar el agente";
  static TEXT_OBESERVATION: string = "Se requiere observación";
  static TEXT_RESIGNATION_FUNERAL: string =
    "si renuncia al auxilio funerario, se eliminaran los beneficiarios agregados obligatoriamente.";
  static TEXT_DATE_MIN_OLD: string =
    "La fecha ingresada no cumple con la mayoria de edad";
  static TEXT_DATE_CURRENT_MAX: string =
    "la fecha ingresada debe ser mayor a la actual";
  static TEXT_DATE_CURRENT_MIN: string =
    "la fecha ingresada debe ser menor a la actual";
  static TEXT_EXPIRE_TOKEN: string = "Expirado su cuenta";
  static TEXT_TYPE_FORMAT_ERROR: string = "El formato es incorrecto";
  static TOOLTIP_TYPING_SEARCH: string = "Escribir para buscar";
  static TEXT_INVALID_AGE_VS_TYPE_DOC: string =
    "La persona de {0} años no es valido el tipo de documento {1} selecionado";
  static TEXT_UPDATE_DATA: string = "Se actualizo";
  static TEXT_CREATE_DATA: string = "Se creo";
  static TEXT_TYPE_DOC_EXIST: string =
    "El beneficiario con tipo de documento, numero de identificacion y tipo de beneficiario ya existe";
  static TEXT_CLOSE_SOLICITUDE: string =
    "¿Desea cerrar este proceso de vinculacion en el sistema?";
  static TITLE_CLOSE_SOLICITUDE: string = "Cerrar Solicitud";
  static TEXT_CONFIRM_CLOSE_SOLICITUDE: string = "Solicitud Cerrada";
  static NOT_VALID_NOT_ROBOT: string = "Favor marcar la casilla de verificación: No soy un robot";
  static TEXT_BENEFICIARIOS_INCORRECT: string =
    "Existen beneficiarios con informacion incorrecta";
  static TEXT_MESSAGE_BIRTH_DAY: string = "La fecha no es valida";
  static TEXT_MESSAGE_SERNIODATE: string = "La persona debe ser mayor de edad";
  static TEXT_DATE_ERROR: string = "Fecha incorrecta";

  static TEXT_REOPEN_SOLICITUDE: string =
    "Este proceso no es reversible, ¿desea confirmar el cambio de estado de la solicitud?";
  static TITLE_REOPEN_SOLICITUDE: string = "Reabrir solicitud";
  static TEXT_SELECT_FINALIZAR: string = "Se requiere seleccionar un Estado";
  static NOT_FOUNC_CODIGO_CIIU: string = "Codigo CIIU No Encontrado";
  static TEXT_PARENTESCO_REPEAT_MOTHER: string =
    "Ya se encuentra agregado un beneficiario con parentesco de Madre.";
  static TEXT_PARENTESCO_REPEAT_FATHER: string =
    "Ya se encuentra agregado un beneficiario con parentesco de Padre.";
  static TEXT_PARENTESCO_REPEAT_SPOUSE: string =
    "Ya se encuentra agregado un beneficiario con parentesco de Cónyugue.";

  static TEXT_PARENTESCO_VALID_GRANDMOTHER: string =
    "Ya se encuentra agregado Dos Abuelos con género femenino";

  static TEXT_PARENTESCO_VALID_GRANDFATHER: string =
    "Ya se encuentra agregado Dos Abuelos con género masculino";

  static TEXT_PARENTESCO_VALID_INLAWS: string =
    "Solo se permiten maximo dos beneficiarios con parentesco Suegro(a)";

  static VALID_PHONE_LENGTH: string = "El Telefono fijo no puede tener mas de 7 caracteres y solo debe ser numerico";    


  static DONACION_EXIST: string = "Tu donación ya había sido realizada anteriormente. Muchas gracias por su colaboración.";
  static TOOLTIP_APORTE_LIBRE: string = "Aporte libre";
  

}



// WEBPACK FOOTER //
// ./src/app/shared/texts/mesagge-text.ts